import { useState, useEffect, useContext, createContext } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

export const OperatorsContext = createContext(null);

export const OperatorsListProvider = (props: any) => {
  const [operatorList, setOperatorList] = useState<any[] | null>(null);
  const [loggedUserData, setLoggedUserData] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const location = useLocation();

  useEffect(() => {
    // Skip fetch if user is on auth pages
    const authPaths = ['/login', '/signup', '/forgot-password'];
    const isAuthPage = authPaths.some((path) => location.pathname.includes(path));

    if (!isAuthPage) {
      fetchOperatorsAndUser();
    } else {
      setLoading(false);
    }
  }, [location.pathname]);

  const fetchOperatorsAndUser = async () => {
    try {
      // Fetch operator list (if not cached)
      let storedOperators = localStorage.getItem('operatorList');
      if (!storedOperators) {
        const { data } = await axios.get('/op/table?page=1&size=100&l=1d');
        const opList = data?.data?.map((item: any) => ({
          key: item['Operator Key'],
          name: item.Name,
        })) || [];
        localStorage.setItem('operatorList', JSON.stringify(opList));
        storedOperators = JSON.stringify(opList);
      }
      setOperatorList(JSON.parse(storedOperators));

      // Fetch logged user data (if not cached)
      let storedUser = localStorage.getItem('loggedUserData');
      if (!storedUser || storedUser === '""') {
        const email = localStorage.getItem('email');
        if (email) {
          const { data } = await axios.get(`/op/operatorId/${email}`);
          localStorage.setItem('loggedUserData', JSON.stringify(data));
          storedUser = JSON.stringify(data);
        }
      }
      if (storedUser) {
        setLoggedUserData(JSON.parse(storedUser));
      }
    } catch (error) {
      console.error('Error fetching operator or user data:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <OperatorsContext.Provider
      value={{ operatorList, loggedUserData, loading, setOperatorList, setLoggedUserData }}
      {...props}
    />
  );
};

export const useOperatorsState = () => {
  const context: any = useContext(OperatorsContext);
  if (!context) {
    throw new Error('useOperatorsState must be used within an OperatorsListProvider');
  }
  return {
    ...context,
    isLoading: context.loading,
    isAuthenticated: !!context.loggedUserData,
  };
};
